import moment from "moment";
import EventMarketButton from "../../events/EventMarketButton";
import { isMobile } from "react-device-detect";
import BetSlip from "../BetSlip";
import {
  addExchangeBet,
  EventDTO,
  MatchOddsDTO,
  MatchOddsRunnerDTO,
  oneClickBetPlaceHandler,
  PlaceBetRequest,
  showToast,
  useAppDispatch,
  useAppSelector,
  setAlertMsg
} from "@hypexone/uicore";

interface MatchOddsRowProps {
  minStake: any;
  maxStake: any;
  eventData: EventDTO;
  marketName: string;
  matchOddsData: MatchOddsDTO;
  runner: MatchOddsRunnerDTO;
  // marketLimits: any;
  getOpenBetsPL: (
    marketId: string,
    marketName: string,
    runner: MatchOddsRunnerDTO,
    type: string
  ) => number[];
  getTotalPL: (
    marketId: string,
    marketName: string,
    runner: MatchOddsRunnerDTO,
    bets: PlaceBetRequest[],
    exposure: any
  ) => number[];
  disabledStatus: string[];
  bets: PlaceBetRequest[];
  selectedRow: string;
  setSelectedRow: (data: string) => void;
  setBetStartTime?: Function;
  setAddNewBet?: Function;
  exposure?: any;
  // open?: String[];
  // setOpen?: (data: string[]) => void;
  // index?: number;
}

const MatchOddsRow: React.FC<MatchOddsRowProps> = ({
  minStake,
  maxStake,
  eventData,
  marketName,
  // marketLimits,
  matchOddsData,
  runner,
  getOpenBetsPL,
  getTotalPL,
  disabledStatus,
  bets,
  setSelectedRow,
  setAddNewBet,
  setBetStartTime,
  exposure
}) => {
  const dispatch = useAppDispatch();
  const { isOneClickBettingEnabled, isOneClickBettingLoading } = useAppSelector((state) => state.betSlip);
  const { langData } = useAppSelector((state) => state.cms);

  // Helper function to check if market is suspended (considering event-level suspend)
  const isMarketSuspended = (marketSuspend: boolean) => {
    return eventData?.eventSuspended === true ? true : marketSuspend;
  };

  const isOddDisable = (
    eventData: EventDTO,
    status: string,
    suspend: boolean,
    betType: string,
    odd: number | null,
    marketTime?: Date
  ) => {
    if (disabledStatus.includes(status.toLowerCase()) || eventData?.eventSuspended === true || suspend === true)
      return true;
    // BBL CUP
    if (matchOddsData?.marketName.toLowerCase().includes("winner"))
      return false;

    if (["7", "4339"].includes(eventData?.sportId)) {
      if (betType === "lay") return true;

      let duration = moment.duration(moment(marketTime).diff(moment()));
      return duration.asMinutes() < 10 && duration.asMinutes() > 0
        ? false
        : true;
    }

    return eventData?.status === "IN_PLAY" ? false : true;
  };

  return (
    <>
      <tr className="border-b border-b-gray13 h-[43px]" key={matchOddsData.marketId + runner.runnerId}>
        <td className="text-start pl-2 w-[60%] md:w-[40%] h-[43px] hover:bg-[#eeeeee]">
          <div className="flex items-center gap-1 h-full">
            <div className="flex text-[12px] font-[700] font-sans items-center h-full">
              {runner?.runnerName}
              {getOpenBetsPL(
                matchOddsData.marketId,
                matchOddsData.marketName,
                runner,
                "array"
              ).map((ret) =>
                ret !== null ? (
                  <span
                    className={ret >= 0 ? "pl-2 text-[#1b891b] " : "pl-2 text-[#ff3a3a] "}
                  >
                    {ret > 0
                      ? "+" + Number(ret).toFixed(2)
                      : Number(ret).toFixed(2)}
                  </span>
                ) : null
              )}

            </div>
            {getTotalPL(
              matchOddsData.marketId,
              matchOddsData.marketName,
              runner,
              bets,
              exposure
            ).map((ret, idx3) =>
              ret !== null ? (
                <div key={idx3} className="profit-loss-box">
                  <span
                    className={
                      ret >= 0 ? " text-[#1b891b] text-[11px]  font-[700]" : " text-[#ff3a3a] text-[11px]  font-[700]"
                    }
                  >
                    {ret > 0
                      ? `(+${Number(ret).toFixed(2)})`
                      : `(${Number(ret).toFixed(2)})`}
                  </span>
                </div>
              ) : null
            )}
          </div>
        </td>
        <td className="w-[20%] md:w-[30%] h-[43px]" colSpan={isMobile ? 1 : 3}>
          <div className="hidden md:flex md:flex-row-reverse h-full">
            {runner?.backPrices?.length > 0
              ? runner?.backPrices?.map((odds, idx) => (
                <EventMarketButton
                  mainValue={odds?.price}
                  subValue={odds.size}
                  showSubValueinKformat={true}
                  oddType="back-odd"
                  valueType="matchOdds"
                  oddsSet={[
                    runner.backPrices[0]?.price ?? 0,
                    runner.backPrices[1]?.price ?? 0,
                    runner.backPrices[2]?.price ?? 0,
                  ]}
                  key={idx.toString() + runner.runnerId + matchOddsData.marketId}
                  disable={isOddDisable(
                    eventData,
                    matchOddsData.status.toLowerCase(),
                    isMarketSuspended(matchOddsData.suspend),
                    "back",
                    odds.price,
                    matchOddsData.marketTime
                  )}
                  onClick={() => {
                    if (isOneClickBettingLoading) {
                      dispatch(showToast({
                        type: 'error',
                        message: langData?.['betIsInProgress'],
                      }));
                      return;
                    };

                    if (
                      moment(eventData?.openDate).diff(moment(), "hour") <=
                      24 ||
                      eventData?.status === "IN_PLAY" ||
                      disabledStatus.includes(
                        matchOddsData.status.toLowerCase()
                      ) ||
                      matchOddsData.suspend === true ||
                      !["7", "4339"].includes(eventData?.sportId)
                    ) {
                      const betRequest: PlaceBetRequest = {
                        sportId: eventData?.sportId,
                        seriesId: eventData?.competitionId,
                        seriesName: eventData?.competitionName,
                        eventId: eventData?.eventId,
                        eventName: eventData?.eventName,
                        eventDate: eventData?.openDate,
                        marketId: matchOddsData.marketId,
                        marketName: marketName,
                        marketType: "MO",
                        outcomeId: runner.runnerId,
                        outcomeDesc: runner.runnerName,
                        betType: "BACK",
                        amount: 0,
                        oddValue: odds?.price,
                        oddSize: odds.size,
                        sessionPrice: -1,
                        srEventId: eventData?.eventId,
                        srSeriesId: eventData?.competitionId,
                        srSportId: eventData?.sportId,
                        minStake: minStake,
                        maxStake: maxStake,
                        oddLimt:
                          matchOddsData?.marketLimits?.maxOdd?.toString(),
                        mcategory: "ALL",
                      }

                      if (isOneClickBettingEnabled) {
                        dispatch(addExchangeBet(betRequest));
                        dispatch(oneClickBetPlaceHandler(
                          {
                            bets: [betRequest],
                            langData,
                            setAlertMsg,
                            eventData
                          }
                        ));
                      } else {
                        setSelectedRow(runner.runnerId + marketName + 'MO');
                        dispatch(addExchangeBet(betRequest));
                      }
                    }
                  }}
                  customBgColor={
                    idx === 0
                      ? "bg-blue13"
                      : idx === 1
                        ? "bg-blue16"
                        : "bg-blue15"
                  }
                />
              ))
              : Array.from({ length: 3 }, (_, emptyBackIndex) => (
                <EventMarketButton
                  key={emptyBackIndex}
                  oddType="back-odd"
                  mainValue={null}
                  customBgColor={
                    emptyBackIndex === 0
                      ? "bg-blue13"
                      : emptyBackIndex === 1
                        ? "bg-blue16"
                        : "bg-blue15"
                  }
                />
              ))}
          </div>
          <div className="flex md:hidden h-full">
            <EventMarketButton
              mainValue={runner.backPrices[0]?.price}
              subValue={runner.backPrices[0]?.size}
              showSubValueinKformat={true}
              oddType="back-odd"
              valueType="matchOdds"
              disable={isOddDisable(
                eventData,
                matchOddsData.status.toLowerCase(),
                matchOddsData.suspend,
                "back",
                runner.backPrices[0]?.price,
                matchOddsData.marketTime
              )}
              onClick={() => {
                if (isOneClickBettingLoading) {
                  dispatch(showToast({
                    type: 'error',
                    message: langData?.['betIsInProgress'],
                  }));
                  return;
                };

                if (
                  moment(eventData?.openDate).diff(moment(), "hour") <= 24 ||
                  eventData?.status === "IN_PLAY" ||
                      disabledStatus.includes(matchOddsData.status.toLowerCase()) ||
                      isMarketSuspended(matchOddsData.suspend) ||
                  !["7", "4339"].includes(eventData?.sportId)
                ) {
                  const betRequest: PlaceBetRequest = {
                    sportId: eventData?.sportId,
                    seriesId: eventData?.competitionId,
                    seriesName: eventData?.competitionName,
                    eventId: eventData?.eventId,
                    eventName: eventData?.eventName,
                    eventDate: eventData?.openDate,
                    marketId: matchOddsData.marketId,
                    marketName: marketName,
                    marketType: "MO",
                    outcomeId: runner.runnerId,
                    outcomeDesc: runner.runnerName,
                    betType: "BACK",
                    amount: 0,
                    oddValue: runner.backPrices[0].price,
                    oddSize: runner.backPrices[0].size,
                    sessionPrice: -1,
                    srEventId: eventData?.eventId,
                    srSeriesId: eventData?.competitionId,
                    srSportId: eventData?.sportId,
                    minStake: minStake,
                    maxStake: maxStake,
                    oddLimt: matchOddsData?.marketLimits?.maxOdd?.toString(),
                    mcategory: "ALL",
                  }

                  if (isOneClickBettingEnabled) {
                    dispatch(addExchangeBet(betRequest));
                    dispatch(oneClickBetPlaceHandler(
                      {
                        bets: [betRequest],
                        langData,
                        setAlertMsg,
                        eventData
                      }
                    ));
                  } else {
                    setSelectedRow(runner.runnerId + marketName + 'MO');
                    dispatch(addExchangeBet(betRequest));
                  }
                }
              }}
            />
          </div>
        </td>
        <td className="w-[20%] md:w-[30%] h-[43px]" colSpan={isMobile ? 1 : 3}>
          <div className="hidden md:flex h-full">
            {runner?.layPrices?.length > 0
              ? runner?.layPrices.map((odds, idx) => (
                <EventMarketButton
                  mainValue={
                    ["7", "4339"].includes(eventData?.sportId)
                      ? 0
                      : odds?.price
                  }
                  subValue={odds.size}
                  showSubValueinKformat={true}
                  oddType="lay-odd"
                  valueType="matchOdds"
                  oddsSet={[
                    runner.layPrices[0]?.price ?? 0,
                    runner.layPrices[1]?.price ?? 0,
                    runner.layPrices[2]?.price ?? 0,
                  ]}
                  key={idx.toString() + runner.runnerId + matchOddsData.marketId}
                  disable={isOddDisable(
                    eventData,
                    matchOddsData.status.toLowerCase(),
                    isMarketSuspended(matchOddsData.suspend),
                    "lay",
                    odds.price
                  )}
                  onClick={() => {
                    if (isOneClickBettingLoading) {
                      dispatch(showToast({
                        type: 'error',
                        message: langData?.['betIsInProgress'],
                      }));
                      return;
                    };

                    if (
                      moment(eventData?.openDate).diff(moment(), "hour") <=
                      24 ||
                      eventData?.status === "IN_PLAY" ||
                      disabledStatus.includes(
                        matchOddsData.status.toLowerCase()
                      ) ||
                      matchOddsData.suspend === true ||
                      !["7", "4339"].includes(eventData?.sportId)
                    ) {
                      const betRequest: PlaceBetRequest = {
                        sportId: eventData?.sportId,
                        seriesId: eventData?.competitionId,
                        seriesName: eventData?.competitionName,
                        eventId: eventData?.eventId,
                        eventName: eventData?.eventName,
                        eventDate: eventData?.openDate,
                        marketId: matchOddsData.marketId,
                        marketName: marketName,
                        marketType: "MO",
                        outcomeId: runner.runnerId,
                        outcomeDesc: runner.runnerName,
                        betType: "LAY",
                        amount: 0,
                        oddValue: odds?.price,
                        oddSize: odds.size,
                        sessionPrice: -1,
                        srEventId: eventData?.eventId,
                        srSeriesId: eventData?.competitionId,
                        srSportId: eventData?.sportId,
                        minStake: minStake,
                        maxStake: maxStake,
                        oddLimt:
                          matchOddsData?.marketLimits?.maxOdd?.toString(),
                        mcategory: "ALL",
                      }

                      if (isOneClickBettingEnabled) {
                        dispatch(addExchangeBet(betRequest));
                        dispatch(oneClickBetPlaceHandler(
                          {
                            bets: [betRequest],
                            langData,
                            setAlertMsg,
                            eventData
                          }
                        ));
                      } else {
                        setSelectedRow(runner.runnerId + marketName + 'MO');
                        dispatch(addExchangeBet(betRequest));
                      }
                    }
                  }}
                  customBgColor={
                    idx === 0
                      ? "bg-pink1"
                      : idx === 1
                        ? "bg-pink2"
                        : "bg-pink3"
                  }
                />
              ))
              : Array.from({ length: 3 }, (_, emptyLayIndex) => (
                <EventMarketButton
                  key={emptyLayIndex}
                  oddType="lay-odd"
                  mainValue={null}
                  customBgColor={
                    emptyLayIndex === 0
                      ? "bg-pink1"
                      : emptyLayIndex === 1
                        ? "bg-pink2"
                        : "bg-pink3"
                  }
                />
              ))}
          </div>

          <div className="flex md:hidden h-full">
            <EventMarketButton
              mainValue={
                ["7", "4339"].includes(eventData?.sportId)
                  ? 0
                  : runner.layPrices[0]?.price
              }
              subValue={runner.layPrices[0]?.size}
              showSubValueinKformat={true}
              oddType="lay-odd"
              valueType="matchOdds"
              disable={isOddDisable(
                eventData,
                matchOddsData?.status?.toLowerCase(),
                matchOddsData.suspend,
                "lay",
                runner?.layPrices[0]?.price
              )}
              onClick={() => {
                if (isOneClickBettingLoading) {
                  dispatch(showToast({
                    type: 'error',
                    message: langData?.['betIsInProgress'],
                  }));
                  return;
                };

                if (
                  moment(eventData?.openDate).diff(moment(), "hour") <= 24 ||
                  eventData?.status === "IN_PLAY" ||
                      disabledStatus.includes(matchOddsData.status.toLowerCase()) ||
                      isMarketSuspended(matchOddsData.suspend) ||
                  !["7", "4339"].includes(eventData?.sportId)
                ) {
                  const betRequest: PlaceBetRequest = {
                    sportId: eventData?.sportId,
                    seriesId: eventData?.competitionId,
                    seriesName: eventData?.competitionName,
                    eventId: eventData?.eventId,
                    eventName: eventData?.eventName,
                    eventDate: eventData?.openDate,
                    marketId: matchOddsData.marketId,
                    marketName: marketName,
                    marketType: "MO",
                    outcomeId: runner.runnerId,
                    outcomeDesc: runner.runnerName,
                    betType: "LAY",
                    amount: 0,
                    oddValue: runner.layPrices[0]?.price,
                    oddSize: runner.layPrices[0]?.size,
                    sessionPrice: -1,
                    srEventId: eventData?.eventId,
                    srSeriesId: eventData?.competitionId,
                    srSportId: eventData?.sportId,
                    minStake: minStake,
                    maxStake: maxStake,
                    oddLimt: matchOddsData?.marketLimits?.maxOdd?.toString(),
                    mcategory: "ALL",
                  }

                  if (isOneClickBettingEnabled) {
                    dispatch(addExchangeBet(betRequest));
                    dispatch(oneClickBetPlaceHandler(
                      {
                        bets: [betRequest],
                        langData,
                        setAlertMsg,
                        eventData
                      }
                    ));
                  } else {
                    setSelectedRow(runner.runnerId + marketName + 'MO');
                    dispatch(addExchangeBet(betRequest));
                  }
                }
              }}
            />
          </div>
        </td>
      </tr>
      {!isOneClickBettingEnabled && bets?.length > 0 &&
        bets?.[0]?.marketName === marketName &&
        bets?.[0]?.marketId === matchOddsData.marketId &&
        bets?.[0]?.outcomeId === runner.runnerId ? (
        <tr>
          <td colSpan={7}>
            <BetSlip
              eventData={eventData}
              setBetStartTime={(date) => setBetStartTime(date)}
              setAddNewBet={(val) => setAddNewBet(val)}

            />
          </td>
        </tr>
      ) : null}
    </>
  );
};

export default MatchOddsRow;
